﻿import React from "react";
import { useTypedSelector } from "../../hooks/useTypeSelector";
import { i18n } from "../../helpers/localisation-helpers";

interface ProductCaseStudyProps {
    thumbUrl: string;
    itemIndex: number;
    title: string;
    intro: string;
    isOldSystem: boolean;
    urlSlug: string;
    caseStudyId: number;
    caseStudyUrl: string;
    expandCaseStudies: boolean;
}

const ProductCaseStudy = (props: ProductCaseStudyProps) => {
    const { productData } = useTypedSelector((state) => state.product);
    return (
        <div className={props.itemIndex <= 3 || props.expandCaseStudies ? "productpage-reviewitem topitem" : "productpage-reviewitem"} itemProp="casestudy">
            <div className="ri-left">
                <img src={`/ContentStorage/Generic/CaseStudy/clientlogo/${props.thumbUrl}.jpg`} alt={props.title} />
            </div>
            <div className="ri-right">
                <h5>{props.title}</h5>
                <div itemProp="reviewBody">{props.intro}</div>
                <div>
                    <a href={props.caseStudyUrl}><span>{i18n("Resource.ReadMore", productData.PageLocalisations)}</span></a>
                </div>
            </div>
        </div>
    )
}

export default ProductCaseStudy;